export default __webpack_public_path__ + "static/media/arrowBackBlack.2735be6f.svg";